import React, { useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import ImgCopy from "../../assets/copy.png";

const ChatMessage = ({ message }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [message]);

  const handleCopy = async () => {
    console.log(message?.text);

    if (!message?.text) return;

    try {
      await navigator.clipboard.writeText(message.text);
      alert("Copied!");
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  if (!message?.text) return null;

  return (
    <div>
      <div
        className={`chat-message ${
          message.sender === "bot" ? "left" : "right"
        }`}
      >
        <div className="message">
          <strong>
            {message.sender === "bot" ? "Competiscan Chatbot:" : "You:"}
          </strong>
          <ReactMarkdown>{message.text}</ReactMarkdown>
        </div>

        <button
          className="copy-btn"
          onClick={handleCopy}
          title="Copy"
          style={{
            right: message.sender === "bot" ? "-26px" : "auto",
            left: message.sender === "bot" ? "auto" : "-26px",
          }}
        >
          <img
            src={ImgCopy}
            alt="copy"
            style={{ height: "20px", width: "20px" }}
          />
        </button>

        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default ChatMessage;
